// uncomment below to engage why did you render
import '../styles/globals.css';

import { AppProps } from 'next/app';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();

  useEffect(() => {
    router.push('/');
  }, []);

  return <Component {...pageProps} />;
}

export default MyApp;
